








































































import { defineComponent, PropType, computed } from '@nuxtjs/composition-api'
import { encodeName } from '~/lib/utilities'
import { NewsItem } from '~/types/blog'

export default defineComponent({
  name: 'BlogArticle',

  props: {
    article: {
      type: Object as PropType<NewsItem>,
      default: () => {},
    },
  },

  setup(props) {
    const getUrl = (url: string) => {
      return encodeName(url) as string
    }

    const getSummary = (content: string) => {
      const text = content?.replace(/<[^>]*>/g, '') ?? ''
      return text.length > 275 ? `${text.slice(0, 275)}...` : text
    }

    const summary = computed(() =>
      getSummary(props.article.summary || props.article.text)
    )

    return {
      getUrl,
      summary,
    }
  },
})
